import React from "react";
import { Link } from "react-router-dom";
import "./component-styles.scss";

function CompleteProfileBanner(props) {
    return(
        <div className="row py-sm-3 py-2 px-2 complete-profile-banner">
            {
                (props.onboarding_form_completed && props.onboarding_form_completed.toLowerCase() === "true")
                ?
                (<div className="col-12 pt-lg-2 pt-sm-1">
                    <span className="text-justify pl-lg-3 pl-md-3">
                        Your onboarding form request is under process. We will update you shortly.
                    </span>
                </div>)
                :
                <>
                    <div className="col-lg-5 col-8 p-0 pt-lg-2 pt-sm-1">
                        <span className="text-justify pl-lg-3 pl-md-3">
                            Complete your profile to get full access to connect2clinic.
                        </span>
                    </div>
                    <div className="col-lg-7 col-4 pt-1 pt-lg-0 pt-md-0 pt-sm-0">
                        {
                            (props.doctor_onboard_link && props.doctor_onboard_link !== "")
                            ?
                            <Link className="btn btn-primary btn-sm rounded-pill px-3 px-md-4 py-sm-2"
                                target="_blank"
                                rel="noreferrer"
                                to={{
                                    pathname: props.doctor_onboard_link
                                }}
                            >Complete Now</Link>
                            : 
                            <button disabled
                                className="btn btn-default btn-sm rounded-pill px-3 px-md-4 py-sm-2" 
                                title="Sorry, the link is currently unavailable">
                                Complete Now
                            </button>
                        }
                    </div>
                </>
            }
        </div>
    )
}

export default CompleteProfileBanner;